import tippy from "tippy.js"; // https://atomiks.github.io/tippyjs/v6/all-props/



let copy_url_tippy = tippy('.js-share-buttons-copy-url', {
  trigger: 'click',
  hideOnClick: false,
  duration: 400,
  onShow(instance) {
    setTimeout(() => {
      instance.hide();
    }, 2000);
  }
})

$('.js-share-buttons-copy-url').click(function(){
  // copy text from attribute
  let copyText = $(this).attr('data-text');
  let textarea = document.createElement("textarea");
  textarea.textContent = copyText;
  textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");

  document.body.removeChild(textarea);
})
